import { Button } from "@/components/ui/button";
import { ArrowRight, Star, Shield, Truck } from "lucide-react";
export const HeroSection = () => {
  return <section id="accueil" className="bg-gradient-to-br from-orange-50 to-gray-100 py-20 scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6">
              Outils Professionnels
              <span className="text-orange-500 block">Elite Performance</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Découvrez nos disques diamantés Elite Precision pour carreleurs et ElitePro pour maçons. 
              Des outils de haute qualité conçus pour les professionnels exigeants.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <a href="#produits" className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-medium transition-colors inline-flex items-center justify-center">
                Voir nos Produits
                <ArrowRight className="ml-2 h-5 w-5" />
              </a>
              <a href="#contact" className="border border-orange-500 text-orange-500 hover:bg-orange-50 px-6 py-3 rounded-lg font-medium transition-colors inline-flex items-center justify-center">
                Demander un Devis
              </a>
            </div>

            <div className="grid grid-cols-3 gap-6 text-center">
              <div className="flex flex-col items-center">
                <Star className="h-8 w-8 text-yellow-500 mb-2" />
                <span className="text-sm font-semibold">Qualité Premium</span>
              </div>
              <div className="flex flex-col items-center">
                <Shield className="h-8 w-8 text-green-500 mb-2" />
                <span className="text-sm font-semibold">Garantie Pro</span>
              </div>
              <div className="flex flex-col items-center">
                <Truck className="h-8 w-8 text-orange-500 mb-2" />
                <span className="text-sm font-semibold">Livraison Rapide</span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <iframe 
                className="w-full rounded-lg mb-4 h-[320px]"
                src="https://www.youtube.com/embed/6ELphF_YICY?autoplay=1&mute=1&loop=1&playlist=6ELphF_YICY&controls=0&showinfo=0&rel=0&modestbranding=1"
                title="Disque Elite Precision - Démonstration"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">Elite Precision</h3>
                <p className="text-gray-600">Spécialement conçu pour les carreleurs professionnels</p>
              </div>
            </div>
            
            {/* Floating card */}
            <div className="absolute -bottom-6 -left-6 bg-orange-500 text-white p-4 rounded-lg shadow-lg">
              <div className="text-2xl font-bold">+5000</div>
              <div className="text-sm">Professionnels satisfaits</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};